import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomeScreen } from './screens/HomeScreen';
import { FocusScreen } from './screens/FocusScreen';
import { RewardScreen } from './screens/RewardScreen';
import { StatsScreen } from './screens/StatsScreen';
import { AccountScreen } from './screens/AccountScreen';
import './styles/global.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/focus" element={<FocusScreen />} />
        <Route path="/reward" element={<RewardScreen />} />
        <Route path="/stats" element={<StatsScreen />} />
        <Route path="/account" element={<AccountScreen />} />
      </Routes>
    </BrowserRouter>
  );
}
